<div
    [ngClass]="{
        'md:pt-(--navigation-height)': automaticNavbarPadding,
    }"
    class="flex h-full scroll-pt-16 flex-col">
    @if (!disable) {
        <nav
            class="navigation-bar"
            [ngClass]="{
                'md:bg-grey-100/87!': navigationService.isNavbarInverseColors(),
                'md:bg-white/24!': !navigationService.isNavbarInverseColors(),
                'hidden md:block': hideMainNavigationOnMobile,
            }">
            <app-main-navigation
                [navbarInverseColors]="
                    navigationService.isNavbarInverseColors()
                ">
            </app-main-navigation>
        </nav>
    }
    <div
        class="order-1 min-h-full w-full md:order-3 md:flex md:h-full md:min-h-auto md:flex-col">
        @if (isImpersonating()) {
            <app-impersonation-banner></app-impersonation-banner>
        }
        <main
            class="flex min-h-full w-full grow flex-col md:min-h-auto"
            [ngClass]="additionalClasses">
            <ng-content></ng-content>
        </main>
        @if (footer) {
            <div>
                @defer (hydrate on viewport) {
                    <app-desktop-footer></app-desktop-footer>
                }
            </div>
        }
    </div>
    <app-sidebar
        [isNavbarInverseColors]="
            navigationService.isNavbarInverseColors()
        "></app-sidebar>
    <div class="h-28 w-full"></div>
</div>
<app-modal></app-modal>
<app-cookie-consent-modal></app-cookie-consent-modal>
